module.exports = {
  minimumAge: 18,      // minimum age to signup.
  maximumAge: 90,     // maximum age at signup.
  minPassLength: 6,     // minimum password length.
  minUsernameLength: 3, // minimum username length.
  minimumHeight: 150, // min height in CM
  maximumHeight: 215 // max height in CM
}



// WEBPACK FOOTER //
// ./src/config/User.js